import { render } from "./HomePageSliderComponent.vue?vue&type=template&id=99b0c264"
import script from "./HomePageSliderComponent.vue?vue&type=script&lang=js"
export * from "./HomePageSliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__